import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, MapPin, Clock, Phone } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_northern-lights-glow/artifacts/m9am00yr_6FCF8E66-33C7-4E29-A59C-D19380935074.PNG";

// TikTok icon component (not in lucide-react)
const TikTokIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

const Footer = () => {
  return (
    <footer className="relative py-12 px-4 border-t border-white/10" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Logo & About */}
          <div className="md:col-span-1">
            <Link to="/">
              <img src={LOGO_URL} alt="Glamour Body" className="h-16 mb-4" />
            </Link>
            <p className="text-white/60 text-sm">
              Advanced Skin • Sculpt • Smooth<br />
              Where confidence begins.
            </p>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-white/60 hover:text-cyan-400 text-sm transition-colors">Home</Link></li>
              <li><Link to="/services" className="text-white/60 hover:text-cyan-400 text-sm transition-colors">Services</Link></li>
              <li><Link to="/gallery" className="text-white/60 hover:text-cyan-400 text-sm transition-colors">Gallery</Link></li>
              <li><Link to="/about" className="text-white/60 hover:text-cyan-400 text-sm transition-colors">About Kandi</Link></li>
              <li><Link to="/contact" className="text-white/60 hover:text-cyan-400 text-sm transition-colors">Book Appointment</Link></li>
              <li><Link to="/gift-cards" className="text-white/60 hover:text-cyan-400 text-sm transition-colors">Gift Cards</Link></li>
            </ul>
          </div>
          
          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li><Link to="/services" className="text-white/60 hover:text-cyan-400 text-sm transition-colors">Facial Treatments</Link></li>
              <li><Link to="/services" className="text-white/60 hover:text-cyan-400 text-sm transition-colors">Body Contouring</Link></li>
              <li><Link to="/services" className="text-white/60 hover:text-cyan-400 text-sm transition-colors">Waxing Services</Link></li>
              <li><Link to="/services" className="text-white/60 hover:text-cyan-400 text-sm transition-colors">VIP Packages</Link></li>
            </ul>
          </div>
          
          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-white/60 text-sm">
                <Mail size={16} className="text-cyan-400" />
                <a href="mailto:Glamourbodyhouston@gmail.com" className="hover:text-cyan-400 transition-colors">
                  Glamourbodyhouston@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-2 text-white/60 text-sm">
                <MapPin size={16} className="text-cyan-400" />
                Katy, Texas
              </li>
              <li className="flex items-center gap-2">
                <Phone size={16} className="text-cyan-400" />
                <a href="tel:+13466378114" className="text-white/60 hover:text-cyan-400 text-sm transition-colors" data-testid="footer-phone">
                  (346) 637-8114
                </a>
              </li>
              <li className="flex items-center gap-2 text-white/60 text-sm">
                <Clock size={16} className="text-cyan-400" />
                By Appointment
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/40 text-sm">&copy; 2026 Glamour Body. All rights reserved.</p>
            
            <div className="flex items-center gap-6">
              <a 
                href="https://instagram.com/Glamourbodyllc" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-white/60 hover:text-cyan-400 transition-colors" 
                data-testid="footer-instagram"
                aria-label="Follow us on Instagram"
              >
                <Instagram size={24} />
              </a>
              <a 
                href="https://tiktok.com/@glamourbody19" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-white/60 hover:text-cyan-400 transition-colors" 
                data-testid="footer-tiktok"
                aria-label="Follow us on TikTok"
              >
                <TikTokIcon size={24} />
              </a>
              <a 
                href="https://www.facebook.com/profile.php?id=61571668773087" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-white/60 hover:text-cyan-400 transition-colors" 
                data-testid="footer-facebook"
                aria-label="Follow us on Facebook"
              >
                <Facebook size={24} />
              </a>
            </div>
          </div>
          <p className="text-white/30 text-xs mt-4 text-center">Website Created by <a href="https://www.GregMiceli.com" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-cyan-400 transition-colors">www.GregMiceli.com</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
